import { render, staticRenderFns } from "./AdminMarketPlace.vue?vue&type=template&id=61a760a6&scoped=true"
import script from "./AdminMarketPlace.vue?vue&type=script&lang=js"
export * from "./AdminMarketPlace.vue?vue&type=script&lang=js"
import style0 from "./AdminMarketPlace.vue?vue&type=style&index=0&id=61a760a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a760a6",
  null
  
)

export default component.exports